import { render, staticRenderFns } from "./ManualDelete.vue?vue&type=template&id=9b953bfe"
import script from "./ManualDelete.vue?vue&type=script&lang=js"
export * from "./ManualDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports